import React from 'react';
import { Button, Group } from '@economic/taco';
import { t } from '@lingui/macro';

interface ButtonCancelSubmitProps {
    onSubmit?: () => void;
    onCancel?: () => void;
    submitText?: string;
    cancelText?: string;
    disableSubmit?: boolean;
}

export default function ButtonCancelSubmit({
    onSubmit = () => {},
    onCancel = () => {},
    submitText = t`Ok`,
    cancelText = t`Cancel`,
    disableSubmit = false,
}: ButtonCancelSubmitProps) {
    return (
        <Group>
            <Button appearance="default" onClick={onCancel}>
                {cancelText}
            </Button>
            <Button appearance="primary" type="submit" onClick={() => onSubmit()} disabled={disableSubmit}>
                {submitText}
            </Button>
        </Group>
    );
}
